import { useState } from "react";
import { heroStats, luckyBoxes } from "@/mocks/openSteps";

export default function Hero() {
  const [lucky, setLucky] = useState<string | null>(null);
  const [count, setCount] = useState(0);

  const drawBox = () => {
    const next = luckyBoxes[Math.floor(Math.random() * luckyBoxes.length)];
    setLucky(next);
    setCount((prev) => prev + 1);
  };

  return (
    <section id="top" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div className="animate-fade-up">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs text-primary-800">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-flashlight-fill text-primary-500" />
                </span>
                本周六 20:00 开箱直播记录
              </span>
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs text-accent-800">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-goblet-line text-accent-600" />
                </span>
                试吃团 3 人同步测评
              </span>
            </div>

            <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
              美味的快递
              <span className="mt-2 block text-primary-600">
                盲盒开箱、零食试吃与惊喜
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里记录每一次拆开零食盲盒的过程：这一盒里装了什么、每样零食吃起来是什么感觉、哪些是真正的惊喜、哪些只是包装好看。如果你喜欢盲盒开箱，又想知道零食试吃的真实反馈，可以从下面的速报和试吃清单开始逛。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#flash"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-inbox-unarchive-line text-base" />
                看本周开箱速报
              </a>
              <a
                href="#tasting"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <i className="ri-restaurant-line text-base" />
                浏览零食试吃清单
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 flex items-baseline gap-1">
                    <span className="font-heading text-2xl text-foreground-950 md:text-3xl">
                      {stat.value}
                    </span>
                    <span className="text-xs text-foreground-500">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="animate-fade-up">
            <div className="relative overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20flat%20illustration%20of%20an%20open%20kraft%20paper%20snack%20box%20with%20wrapped%20candies%20cookies%20chips%20and%20nuts%20spilling%20out%20neatly%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20light%20beige%20background%2C%20soft%20grain%20texture%2C%20cheerful%20editorial%20food%20illustration&width=1200&height=900&seq=snackbox-hero-main-01&orientation=landscape"
                alt="一只被打开的零食盲盒，里面装着糖果、曲奇、薯片和坚果"
                className="h-56 w-full object-cover md:h-72"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-800">
                <i className="ri-box-3-line text-primary-600" />
                本季第 12 期盲盒
              </span>
            </div>

            <div className="mt-4 rounded-lg border border-secondary-200 bg-secondary-50 p-4 md:p-5">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className="ri-shuffle-line" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">
                      今日幸运盲盒
                    </p>
                    <p className="text-xs text-foreground-500">
                      点一下，随机抽一款本期零食
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={drawBox}
                  className="shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
                >
                  抽一盒
                </button>
              </div>

              <div className="mt-4 flex min-h-[3rem] items-center justify-center rounded-md border border-dashed border-secondary-300 bg-background-50 px-4 py-3 text-center">
                {lucky ? (
                  <p key={count} className="animate-pop-in text-sm text-foreground-900">
                    你抽到的是
                    <span className="mx-1.5 font-heading text-base text-primary-700">
                      {lucky}
                    </span>
                    ，记得在试吃清单里找找它。
                  </p>
                ) : (
                  <p className="text-sm text-foreground-500">
                    还没有抽奖，先按一下右边的「抽一盒」。
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}